import type { LucideIcon } from 'lucide-react';
import { CalendarRange, Flame, LayoutDashboard, PackageX, Trophy, ListChecks } from 'lucide-react';

/**
 * Eksempelspørsmål på startsiden. De viser bredden (oversikt med flere paneler, varmekart, topp-lister,
 * periodesammenligning) og er valgt slik at Compass lager gode visninger av dem.
 */
export interface CompassExample {
    key: string;
    icon: LucideIcon;
    titleDefault: string;
    descriptionDefault: string;
    promptDefault: string;
}

export const COMPASS_EXAMPLES: CompassExample[] = [
    {
        key: 'pickOverview',
        icon: LayoutDashboard,
        titleDefault: 'Plukkoversikt',
        descriptionDefault: 'Nøkkeltall, utvikling per dag og per operatør',
        promptDefault: 'Gi meg en oversikt over plukkingen de siste 4 ukene: nøkkeltall, plukkede linjer per dag og plukkede linjer per operatør.'
    },
    {
        key: 'topItems',
        icon: Trophy,
        titleDefault: 'Mest plukkede varer',
        descriptionDefault: 'Topp 20 og hvor de ligger på lageret',
        promptDefault: 'Hvilke 20 varer plukkes oftest de siste 60 dagene, og hvor ligger de? Vis andel av alle plukk.'
    },
    {
        key: 'heatmap',
        icon: Flame,
        titleDefault: 'Når på døgnet er det travelt?',
        descriptionDefault: 'Varmekart per ukedag og time',
        promptDefault: 'Lag et varmekart over antall lagertransaksjoner per ukedag og time de siste 12 månedene.'
    },
    {
        key: 'weekCompare',
        icon: CalendarRange,
        titleDefault: 'Denne uken mot forrige',
        descriptionDefault: 'Sammenligning per ukedag',
        promptDefault: 'Sammenlign plukkingen denne uken med forrige uke per ukedag, med nøkkeltall for totalen og endring i prosent.'
    },
    {
        key: 'openWork',
        icon: ListChecks,
        titleDefault: 'Åpent arbeid nå',
        descriptionDefault: 'Ordrer og plukklister per status',
        promptDefault: 'Hvor mange åpne ordrer og plukklister har vi per status nå?'
    },
    {
        key: 'deadStock',
        icon: PackageX,
        titleDefault: 'Varer uten bevegelse',
        descriptionDefault: 'Saldo, men ikke rørt på 120 dager',
        promptDefault: 'Hvilke varer har saldo på lager, men ingen bevegelse de siste 120 dagene? Vis antall, lokasjon og siste bevegelse.'
    }
];
